import React, { useState } from 'react';
interface ShippingFormProps {
  initialValues: {
    firstName: string;
    lastName: string;
    email: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    phone: string;
  };
  onSubmit: (values: ShippingFormProps['initialValues']) => void;
}
export const ShippingForm: React.FC<ShippingFormProps> = ({
  initialValues,
  onSubmit
}) => {
  const [formValues, setFormValues] = useState(initialValues);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = {
          ...prev
        };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formValues.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formValues.lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!formValues.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formValues.address.trim()) newErrors.address = 'Address is required';
    if (!formValues.city.trim()) newErrors.city = 'City is required';
    if (!formValues.state.trim()) newErrors.state = 'State is required';
    if (!formValues.zipCode.trim()) newErrors.zipCode = 'ZIP code is required';
    if (!formValues.phone.trim()) newErrors.phone = 'Phone number is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formValues);
    }
  };
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6" data-id="element-272">
      <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-273">
        Shipping Information
      </h2>
      <form onSubmit={handleSubmit} data-id="element-274">
        <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2" data-id="element-275">
          <div data-id="element-276">
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700" data-id="element-277">
              First name
            </label>
            <input type="text" id="firstName" name="firstName" value={formValues.firstName} onChange={handleChange} className={`mt-1 block w-full border ${errors.firstName ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-278" />
            {errors.firstName && <p className="mt-1 text-sm text-red-600" data-id="element-279">{errors.firstName}</p>}
          </div>
          <div data-id="element-280">
            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700" data-id="element-281">
              Last name
            </label>
            <input type="text" id="lastName" name="lastName" value={formValues.lastName} onChange={handleChange} className={`mt-1 block w-full border ${errors.lastName ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-282" />
            {errors.lastName && <p className="mt-1 text-sm text-red-600" data-id="element-283">{errors.lastName}</p>}
          </div>
          <div className="sm:col-span-2" data-id="element-284">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-285">
              Email address
            </label>
            <input type="email" id="email" name="email" value={formValues.email} onChange={handleChange} className={`mt-1 block w-full border ${errors.email ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-286" />
            {errors.email && <p className="mt-1 text-sm text-red-600" data-id="element-287">{errors.email}</p>}
          </div>
          <div className="sm:col-span-2" data-id="element-288">
            <label htmlFor="address" className="block text-sm font-medium text-gray-700" data-id="element-289">
              Street address
            </label>
            <input type="text" id="address" name="address" value={formValues.address} onChange={handleChange} className={`mt-1 block w-full border ${errors.address ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-290" />
            {errors.address && <p className="mt-1 text-sm text-red-600" data-id="element-291">{errors.address}</p>}
          </div>
          <div data-id="element-292">
            <label htmlFor="city" className="block text-sm font-medium text-gray-700" data-id="element-293">
              City
            </label>
            <input type="text" id="city" name="city" value={formValues.city} onChange={handleChange} className={`mt-1 block w-full border ${errors.city ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-294" />
            {errors.city && <p className="mt-1 text-sm text-red-600" data-id="element-295">{errors.city}</p>}
          </div>
          <div data-id="element-296">
            <label htmlFor="state" className="block text-sm font-medium text-gray-700" data-id="element-297">
              State / Province
            </label>
            <input type="text" id="state" name="state" value={formValues.state} onChange={handleChange} className={`mt-1 block w-full border ${errors.state ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-298" />
            {errors.state && <p className="mt-1 text-sm text-red-600" data-id="element-299">{errors.state}</p>}
          </div>
          <div data-id="element-300">
            <label htmlFor="zipCode" className="block text-sm font-medium text-gray-700" data-id="element-301">
              ZIP / Postal code
            </label>
            <input type="text" id="zipCode" name="zipCode" value={formValues.zipCode} onChange={handleChange} className={`mt-1 block w-full border ${errors.zipCode ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-302" />
            {errors.zipCode && <p className="mt-1 text-sm text-red-600" data-id="element-303">{errors.zipCode}</p>}
          </div>
          <div data-id="element-304">
            <label htmlFor="country" className="block text-sm font-medium text-gray-700" data-id="element-305">
              Country
            </label>
            <select id="country" name="country" value={formValues.country} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm" data-id="element-306">
              <option value="United States" data-id="element-307">United States</option>
              <option value="Canada" data-id="element-308">Canada</option>
              <option value="Mexico" data-id="element-309">Mexico</option>
              <option value="United Kingdom" data-id="element-310">United Kingdom</option>
              <option value="Australia" data-id="element-311">Australia</option>
            </select>
          </div>
          <div className="sm:col-span-2" data-id="element-312">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-313">
              Phone number
            </label>
            <input type="tel" id="phone" name="phone" value={formValues.phone} onChange={handleChange} className={`mt-1 block w-full border ${errors.phone ? 'border-red-300' : 'border-gray-300'} rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-fuchsia-500 focus:border-fuchsia-500 sm:text-sm`} data-id="element-314" />
            {errors.phone && <p className="mt-1 text-sm text-red-600" data-id="element-315">{errors.phone}</p>}
          </div>
        </div>
        <div className="mt-8 flex justify-end" data-id="element-316">
          <button type="submit" className="py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-500" data-id="element-317">
            Continue to Payment
          </button>
        </div>
      </form>
    </div>;
};